import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Observable, Subject } from 'rxjs';
import { ContributionTypesEnum, IDataSource } from '@akiba/models_bimbo';
import * as firebase from 'firebase';
import { take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataSourceService implements IDataSource {

  limit = 5000;
  baseURL = 'https://bimboakiba.uc.r.appspot.com';
  callbackWithArray: ((batchResults: Array<any>) => Promise<boolean>) | null = null;
  callbackPendingWithArray: ((batchResults: Array<any>) => Promise<boolean>) | null = null;
  callbackApprovedPendingWithArray: ((batchResults: Array<any>) => Promise<boolean>) | null = null;

  investmentReturnStatus$: Subject<string> = new Subject();

  constructor(
    private firestore: AngularFirestore,
    private fns: AngularFireFunctions,
    private real: AngularFireDatabase,
    public http: HttpClient
  ) { }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  search(query: any) {
    const callable = this.fns.httpsCallable('search');
    return callable(query).toPromise();
  }

  tokenForSSOEmployee(credentials: any): Promise<any> {
    const callable = this.fns.httpsCallable('createSSOEmployeeIDToken');
    return callable(credentials).toPromise();
  }

  tokenForEmployee(credentials: any): Promise<any> {
    const callable = this.fns.httpsCallable('createEmployeeIDToken');
    return callable(credentials).toPromise();
  }

  tokenForAdmin(credentials: any): Promise<any> {
    const callable = this.fns.httpsCallable('createAdminToken');
    return callable(credentials).toPromise();
  }

  processLoansPendingList(amountAvailable: any): Promise<any> {
    const callable = this.fns.httpsCallable('employeeDataFunctions-processPendingLoans');
    return callable(amountAvailable).toPromise();
  }

  extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
  handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  postLoansPendingList(amountAvailable: any): Promise<any> {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Content-Type', 'application/json');


    const body = JSON.stringify(amountAvailable);
    console.log(body)
    return this.http.post(this.baseURL + '/processLoans', body, { 'headers': headers }).toPromise();

  }


  getReports(peticion: string): Promise<any> {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'GET');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Content-Type', 'application/json');

    console.log('pet', this.baseURL + peticion);


    return this.http.get(this.baseURL + peticion, { 'headers': headers }).toPromise();

  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  loadAllEmployeesModified(startDate: Date, endDate: Date): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('users', ref => ref.where('modificationDate', '>=', startDate).where('modificationDate', '<=', endDate)).get({ source: 'server' });
  }

  loadAllEmployeesModifiedInCompany(startDate: Date, endDate: Date, companyID: string): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('users', ref => ref.where('modificationDate', '>=', startDate).where('modificationDate', '<=', endDate).where('workInformation.companyRef.companyID', '==', companyID)).get({ source: 'server' });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadEmployeesLoansApproved(uid: string): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('employeeLoans', ref => ref.where('employeeRef.employeeNumber', '==', uid).where('active', '==', true)).get({ source: 'server' });
  }

  loadAllEmployeeLoansApproved(startDate: Date, endDate: Date, uid: string): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('employeeLoans', ref => ref.where('employeeRef.employeeNumber', '==', uid).where('createdAt', '>=', startDate).where('createdAt', '<=', endDate).where('active', '==', true)).get({ source: 'server' });
  }

  loadAllEmployeesLoansApproved(startDate: Date, endDate: Date): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('employeeLoans', ref => ref.where('createdAt', '>=', startDate).where('createdAt', '<=', endDate)).get({ source: 'server' });
  }


  loadAllLoansApproved(): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true)).get({ source: 'server' });
  }

  loadAllEmployeesSavingsApproved(startDate: Date, endDate: Date): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('permanentSavings', ref => ref.where('subscriptionDate', '>=', startDate).where('subscriptionDate', '<=', endDate).where('active', '==', true)).get({ source: 'server' });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadAllContributions(type: string, from: number = 0, to: number = 32511138825000): Observable<Array<any>> {
    return this.firestore.collection(type, ref => ref.where('timeStamp', '>=', from).where('timeStamp', '<=', to)).valueChanges();
  }

  loadAllFinancialReturn(type: string, from: number = 0, to: number = 32511138825000): Observable<Array<any>> {
    return this.firestore.collection(type, ref => ref.where('timeStamp', '>=', from).where('timeStamp', '<=', to)).valueChanges();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadEmployeeLoanListItem(loanID: string): Observable<firebase.firestore.DocumentSnapshot> {
    return this.firestore.collection('employeesLoanList').doc(loanID).get();
  }

  loadEmployeeLoanItem(loanID: string): Observable<firebase.firestore.DocumentSnapshot> {
    return this.firestore.collection('employeeLoans').doc(loanID).get();
  }

  loadNotificationsFor(uid: string): Observable<Array<any>> {
    return this.firestore.collection('employeesLoanList', ref => ref.where('supervisor', '==', uid)).valueChanges();
  }

  loadNotificationsForAdmins(): Observable<Array<any>> {
    return this.firestore.collection('employeesLoanList').valueChanges();
  }

  loadWorkFlowFor(uid: string): Observable<Array<any>> {
    return this.firestore.collection('users', ref => ref.where('workInformation.supervisor.employeeNumber', '==', uid)).valueChanges();
  }

  loadPasswordChange(uid: string): Observable<Array<any>> {
    return this.firestore.collection('registeredUsers', ref => ref.where('employeeNumber', '==', uid)).valueChanges();
  }


  loadActiveLoans(): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true).where('status', '==', 'active')).valueChanges();
  }

  loadPendingLoans(uidArray: Array<string>): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true).where('status', '==', 'review').where('employeeRef.employeeNumber', 'in', uidArray).orderBy('createdAt')).valueChanges();
  }

  loadPendingLoan(employeeNumber: string): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true).where('status', '==', 'review').where('employeeRef.employeeNumber', '==', employeeNumber)).valueChanges();
  }

  loadAdministratorPendingLoans(): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true).where('status', '==', 'review').orderBy('createdAt')).valueChanges();
  }

  loadDeniedLoans(uid: string, aDate: Date): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', false).where('status', '==', 'caducado').where('createdAt', '>=', aDate).where('employeeRef.employeeNumber', '==', uid).orderBy('createdAt')).valueChanges();
  }

  loadAdministratorDeniedLoans(aDate: Date): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', false).where('status', '==', 'caducado').where('createdAt', '>=', aDate).orderBy('createdAt')).valueChanges();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadEmployee(uid: string): Observable<any> {
    return this.firestore.collection('users').doc(uid).valueChanges();
  }

  loadAllEmployees(): Observable<any> {
    return this.firestore.collection('users').valueChanges();
  }

  loadPermanentSavings(uid: string): Observable<any> {
    return this.firestore.collection('permanentSavings').doc(uid).valueChanges();
  }

  loadUserLoans(uid: string): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('active', '==', true).where('employeeRef.employeeNumber', '==', uid)).valueChanges();
  }

  loadLoanSchedulePayments(loanID: string): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans').doc(loanID).collection('schedulePayments').valueChanges();
  }

  loadAllUserLoans(uid: string): Observable<Array<any>> {
    return this.firestore.collection('employeeLoans', ref => ref.where('employeeRef.employeeNumber', '==', uid)).valueChanges();
  }


  loadUserLoan(loanID: string): Observable<any> {
    return this.firestore.collection('employeeLoans').doc(loanID).valueChanges();
  }


  loadEmployeeContributions(type: string, employeeNumber: string, from: number = 0, to: number = 32511138825000): Observable<Array<any>> {
    return this.firestore.collection(type, ref => ref.where('employeeNumber', '==', employeeNumber).where('timeStamp', '>=', from).where('timeStamp', '<=', to)).valueChanges();
  }


  loadEmployeeReport(type: string, employeeNumber: string, from: Date, to: Date): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection(type, ref => ref.where('employeeNumber', '==', employeeNumber).
      where('grantDate', '>=', from).where('grantDate', '<=', to)).get();
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadLoan(loanID: string): Observable<unknown> {
    return this.firestore.collection('employeeLoans').doc(loanID).valueChanges();
  }

  loadByStatusLoan(from: Date, to: Date): Observable<firebase.firestore.QuerySnapshot> {
    return this.firestore.collection('employeeLoans', ref => ref.where('createdAt', '>=', from).where('createdAt', '<=', to)).get();
  }

  async saveTheoreticalAvailableAmount(parameterID: string, amountToSubtract: number, activeSavingAccount: boolean): Promise<void> {

    let cityRef = this.firestore.collection('parameters').doc(parameterID).ref;
    return this.firestore.firestore.runTransaction(async (t: any) => {

      return t.get(cityRef).then(doc => {
        let parameter = doc.data();
        if (activeSavingAccount == true) {
          parameter.investmentParameterSavers.theoreticalAvailableAmount -= amountToSubtract;
        } else {
          parameter.investmentParameterNonSavers.theoreticalAvailableAmount -= amountToSubtract;
        }

        t.update(cityRef, parameter);
      });

    }).then(result => {
      console.log('Transaction success!');
      return;
    }).catch(err => {
      console.log('Transaction failure:', err);
      return;
    });

  }

  loadParameters(active: boolean = null): Observable<Array<any>> {

    if (active !== null) {
      return this.firestore.collection('parameters', ref => ref.where('active', '==', active)).valueChanges();
    } else {
      return this.firestore.collection('parameters').valueChanges();
    }

  }

  loadLoanListParameters(active: boolean = null): Observable<Array<any>> {
    //Observable<firebase.firestore.QuerySnapshot>
    if (active !== null) {
      return this.firestore.collection('loanListParameters', ref => ref.where('active', '==', active)).valueChanges();
    } else {
      return this.firestore.collection('loanListParameters').valueChanges();
    }
  }

  updateLoanListParameters(loanListParameters: any) {
    return this.firestore.collection('loanListParameters').doc(loanListParameters.idParameter).update(loanListParameters);
  }

  insertLoanListParameters(loanListParameters: any) {
    return this.firestore.collection('loanListParameters').doc(loanListParameters.idParameter).set(loanListParameters);
  }

  loadParameterByID(id: string): Observable<any> {
    return this.firestore.collection('parameters').doc(id).valueChanges();
  }

  loadInstallments(): Observable<Array<any>> {

    return this.firestore.collection('installment').valueChanges();

  }

  loadPayrolls(active: boolean = null): Observable<Array<any>> {

    if (active !== null) {
      return this.firestore.collection('payroll', ref => ref.where('active', '==', active)).valueChanges();
    } else {
      return this.firestore.collection('payroll').valueChanges();
    }

  }

  loadFundParameters(): Observable<Array<any>> {

    return this.firestore.collection('fundParameters').valueChanges();

  }


  /** funcion para identificar prestamo activo mientras el colaborador est aen lista de espera */

  loadLoanActiveListPending(employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeeLoans').ref;

    let query = collectionRef.where('employeeRef.employeeNumber', '==', employeeNumber).orderBy('createdAt').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }



  async loanActiveInPendingList(employeeNumber: string, createdAt: Date, interestType: string) {

    const type = 'LoanTransactions';
    const to = new Date();
    let monto = 0;
    let long = 0;
    let amortization: number = 0;
    let suma: number = 0;
    let tempArray = [];
    const loanTransactions = await this.loadEmployeeReport(type, employeeNumber, createdAt, to).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    let mappedArray: Array<any> = [];
    let subtype = '';

    if (loanTransactions) {
      loanTransactions.forEach(e => {
        let lt = e.data();
        if (lt.amortization > 0 && ((lt.loanType == 'PCAH' && lt.interest === 0) || (lt.loanType == 'CJPE' && lt.interest > 0))) {
          if (lt.index > 0) {
            tempArray.push({ amortizacion: lt.amortization, index: lt.index });
          }

          if (lt.amortization === 1) {
            amortization += lt.amortization;
          } else {
            suma += lt.amortization;
          }
          long++;
          mappedArray.push(lt);
        }
        subtype = lt.loanType;
      });
    }

    let arraySet = tempArray.filter((thing, index, self) => index === self.findIndex((t) => (t.amortizacion === thing.amortizacion && t.index === thing.index)));
    let longTemp = arraySet.length;

    if (interestType === 'fixed' && longTemp > 0) {
      long = longTemp < long ? longTemp : long;

      arraySet.forEach(element => {
        monto += element.amortizacion;
      });
    } else {
      monto = (long > amortization) ? (suma / (long - amortization)) * long : 0;
    }

    let sumPayments = isNaN(monto) ? 0 : monto;
    let longPayments = (long > amortization) ? long : 0;
    let paid: boolean = (long === amortization) ? true : false

    let result = [{ sumPayments: sumPayments, longPayments: longPayments, subType: subtype, paid: paid }];
    return result;
  }


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async saveLoanRequest(loanObj: any, scheduleDates: any) {
    const id = this.firestore.createId();
    loanObj.loanID = id;
    await this.firestore.collection('employeeLoans').doc(loanObj.loanID).set(loanObj);
    const keys = Object.keys(scheduleDates);
    for (const key of keys) {
      const sd = scheduleDates[key];
      await this.firestore.collection('employeeLoans').doc(loanObj.loanID).collection('schedulePayments').doc(key).set(sd, { merge: true });
    }
    await this.saveLogEmployeeLoanChanges(loanObj, 'saveLoanRequest');
    return;
  }

  updateLoanBonus(loanID: string, bonusObject: any) {
    return this.firestore.collection('employeeLoans').doc(loanID).update({
      bonusPercentage: bonusObject
    });
  }

  /**report bonus perce */
  reportLoanBonus(bonusInfo: any) {
    const id = this.firestore.createId();
    return this.firestore.collection('reportBonusPercentage').doc(id).set(bonusInfo);
  }


  updateLoanRequest(loanObj: any) {
    return this.firestore.collection('employeeLoans').doc(loanObj.loanID).update(loanObj);
  }

  markRestructuredLoan(id: string): Promise<any> {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: 'restructured', active: false });
  }

  markAdvanceLoanPayment(id: string) {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: 'advancePayment', active: false });
  }

  markDeniedRestructuredLoan(id: string): Promise<any> {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: 'active', active: true });
  }

  markAsRejectedLoan(id: string, comment: string): Promise<any> {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: 'caducado', comment: comment, active: false });
  }

  markAsApprovedLoan(id: string, status: string): Promise<any> {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: status });
  }

  deleteEmployeesLoanList(logEmploye: any): Promise<any> {

    this.saveLogAdministratorActions(logEmploye, 'deleteEmployeesLoanList');
    return this.firestore.collection('employeesLoanList').doc(logEmploye.changeID).delete();

  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async updateWithdraws(uid: string): Promise<any> {
    if (!this.firestore) {
      return null;
    }
    return this.firestore.collection('permanentSavings').doc(uid).update({
      withdraws: {}
    });
  }


  async addAmortizationLoanObject(timeStamp: string, array: Array<any>) {

    const countRef = this.real.database.ref('bimboLoansAmortizationOut').child(timeStamp).child('count');
    return countRef.transaction((currentValue) => {
      return (currentValue || 0) + array.length;
    }, async (error, committed, snapshot) => {

      if (error) {
        console.log('transaction error: ', error);
        return null;
      } else if (!committed) {
        return null;
      } else if (snapshot) {

        await this.real.database.ref('bimboLoansAmortizationOut').child(timeStamp).child('writing').set(true);

        let ordinal = snapshot.val() - array.length;
        for (const obj of array) {
          obj.schedulePayment.ordinal = ordinal;
          await this.real.database.ref('bimboLoansAmortizationOut').child(timeStamp).push(obj.schedulePayment);
          ordinal++;
        }

        return this.real.database.ref('bimboLoansAmortizationOut').child(timeStamp).child('writing').set(null);

      }


    });


  }

  loadPendingListIndex(): Observable<firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>> {
    return this.firestore.collection('employeesLoanList', ref => ref.where('listIndex', '>', 0).where('status', '==', 'active_pending').orderBy('listIndex', 'desc').limit(1)).get();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  registerPermanentSavings(uid: string, permanentSavingsObj: any): Promise<any> {
    return this.firestore.collection('permanentSavings').doc(uid).set(permanentSavingsObj);
  }

  updatePermanentSavings(uid: string, permanentSavingsObj: any): Promise<any> {
    return this.firestore.collection('permanentSavings').doc(uid).update(permanentSavingsObj);
  }


  updateBonusPermanentSavings(uid: string, permanentSavingsBonusObj: any): Promise<any> {
    return this.firestore.collection('permanentSavings').doc(uid).update(permanentSavingsBonusObj);
  }

  markWithdrawLoan(id: string, permanentSavingsObj: any): Promise<any> {
    return this.firestore.collection('employeeLoans').doc(id).update({ status: 'withdraw', active: false });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  registerShareSavings(shareSavingsObj: any): Promise<any> {
    const id = this.firestore.createId();
    shareSavingsObj.ssID = id;
    return this.firestore.collection('shareSavings').doc(id).set(shareSavingsObj, { merge: true });
  }


  shareSavings(employeeNumber : string, param : any ) : Promise<any> {
    const collectionRef = this.firestore.collection('shareSavings').ref;
    return collectionRef.where('user.employeeNumber', '==', employeeNumber).where('active', '==', true).where('parametersID', '==', param.activeParameterID).where('scheduleDateID', '==', param.activeScheduleDateID).get();
  }

  shareSavingsUser(employeeNumber : string ) : Promise<any> {
    const collectionRef = this.firestore.collection('shareSavings').ref;
    return collectionRef.where('user.employeeNumber', '==', employeeNumber).get();
  }

  loadSavingContract(uid: string): Observable < any | null> {
    return this.firestore.collection('shareSavings').doc(uid).collection('savingContract').doc('activeContract').snapshotChanges()
    .pipe(
      map(actions => {
        return actions.payload.data();
      })
    );

  }

  markSavingContract(uid: string, action: any): Promise<any> {
    return this.firestore.collection('shareSavings').doc(uid).collection('savingContract').doc('activeContract').update(action);

  }

  markStatusShareSaving(uid: string, action : any): Promise<any> {
    return this.firestore.collection('shareSavings').doc(uid).update(action);

  }


  /// poner aqui el paramID y sheduleID  por terminar 
  getShareSavings(): Promise<firebase.firestore.QuerySnapshot | null> {
    const colleccionRef  = this.firestore.collection('shareSavings').ref;
    return  colleccionRef.where('active','==', true).get();

  }


  loadShareSavings(type: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('active', '==', true).orderBy('registrationDate').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  loadShareSavingsReport(type: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.orderBy('subscriptionDate').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async addShareSavings(action: string, aContributionObject: Array<any>): Promise<any | null> {
    const limitDate = new Date();
    const dataSSDelete = {
      savingType: "shareSavingsUsers",
      limitDate: limitDate
    };

    if (!this.firestore) {
      return null;
    }

    const batch = this.firestore.firestore.batch();

    for (const contribution of aContributionObject) {
      if (contribution.employee) {
        const ref = this.firestore.collection('shareSavingsUsers').doc(contribution.employee.employeeNumber).ref;
        batch.set(ref, contribution.employee);
      }
    }

    const result = batch.commit();

    if (result && action === "new") {

      this.deleteShareSavings(dataSSDelete).catch(error => {
        console.log(error);
      });
    }

    return result;

  }

  async deleteShareSavings(action: any): Promise<any> {
    // borrar e insertar nuevos aqui nos quedamos 
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Content-Type', 'application/json');

    const body = JSON.stringify(action);
    return this.http.post(this.baseURL + '/deleteShareSaving', body, { 'headers': headers }).pipe(take(1)).toPromise() ;


  }



  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  saveParameter(aPeriodObj: any): Promise<any> {
    return this.firestore.collection('parameters').doc(aPeriodObj.parametersID).set(aPeriodObj, { merge: true });
  }

  saveShareSavingsParameter(aPeriodObj: any): Promise<any> {
    return this.firestore.collection('shareSavingsParameters').doc(aPeriodObj.parametersID).set(aPeriodObj);
  }

  loadShareSavingsParameter(): Promise<firebase.firestore.DocumentData | null> {
    const collectionRef = this.firestore.collection('shareSavingsParameters').ref;
    return collectionRef.get();

  }

  loadShareSavingsUser(employeeNumber : string ) : Observable<any> {

    return this.firestore.collection('shareSavingsUsers', ref => ref.where('employeeNumber', '==', employeeNumber).where('active', '==', true)).valueChanges();
  }
 
  loadParameter(id: string): Observable<any> {
    return this.firestore.collection('parameters').doc(id).valueChanges();
  }

  updateParameter(aPeriodObj: any): Promise<any> {
    return this.firestore.collection('parameters').doc(aPeriodObj.parametersID).update(aPeriodObj);
  }

  loadPermanentSavingsParameters(active: boolean): Observable<any> {
    if (active !== null) {
      return this.firestore.collection('parameters', ref => ref.where('active', '==', active)).valueChanges();
    } else {
      return this.firestore.collection('parameters').valueChanges();
    }
  }

  loadRetirementSavingsParameters(active: boolean): Observable<any> {
    if (active !== null) {
      return this.firestore.collection('parameters', ref => ref.where('active', '==', active)).valueChanges();
    } else {
      return this.firestore.collection('parameters').valueChanges();
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  savePayroll(aPayrollObj: any): Promise<any> {
    return this.firestore.collection('payroll').doc(aPayrollObj.payrollParametersID).set(aPayrollObj, { merge: true });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  saveFundParameter(aPeriodObj: any): Promise<any> {
    return this.firestore.collection('fundParameters').doc(aPeriodObj.parametersID).set(aPeriodObj, { merge: true });
  }

  loadFundParameter(id: string): Observable<any> {
    return this.firestore.collection('fundParameters').doc(id).valueChanges();
  }

  updateFundParameter(aPeriodObj: any): Promise<any> {
    return this.firestore.collection('fundParameters').doc(aPeriodObj.parametersID).update(aPeriodObj);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  saveInstallment(anInstallmentObj: any): Promise<any> {
    return this.firestore.collection('installment').doc(anInstallmentObj.installmentID).set(anInstallmentObj);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadDepartments(): Observable<Array<any>> {
    return this.firestore.collection('departments').valueChanges();
  }

  loadCompanies(): Observable<Array<any>> {
    return this.firestore.collection('companies').valueChanges();
  }

  loadContracts(): Observable<Array<any>> {
    return this.firestore.collection('contracts').valueChanges();
  }

  loadWages(): Observable<Array<any>> {
    return this.firestore.collection('wages').valueChanges();
  }

  deleteInstallment(anInstallmentObj: any): Promise<any> {
    return this.firestore.collection('installment').doc(anInstallmentObj.installmentID).delete();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  loadSupervisorPendingLoans(employeeNumber: string) {
    return this.firestore.collection('employeesLoanList', ref => ref.where('supervisor.employeeNumber', '==', employeeNumber).where('status', '==', 'review').orderBy('createdAt', 'asc')).snapshotChanges();
  }

  loadAllPendingLoans(): Observable<DocumentChangeAction<unknown>[]> {
    return this.firestore.collection('employeesLoanList', ref => ref.where('status', '==', 'review').orderBy('createdAt', 'asc')).snapshotChanges();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async loadContributionsByType(type: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).orderBy('timeStamp').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  /*** funcion para reporte CAL , ... FAC, FAL, CAR */
  loadRetirement(type: string, employeeNumber: string): Observable<Array<any>> {
    // .where('timeStamp', '>', 1596258000000)
    return this.firestore.collection(type, ref => ref.where('employeeNumber', '==', employeeNumber)).valueChanges();
  }

  async calAccumulated(companyID: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('CAL_Accumulated').ref;

    let query = collectionRef.orderBy('employeeNumber').limit(batchSize);

    if (companyID != '') {
      query = collectionRef.where('companyID', '==', companyID).orderBy('employeeNumber').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadContributionsByTypeAndSubType(type: string, subType: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;
    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('subType', '==', subType).orderBy('timeStamp').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('subType', '==', subType).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadContributionsByTypeAndCompany(type: string, companyID: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).orderBy('timeStamp').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadContributionsByTypeSubTypeAndCompany(type: string, subType: string, companyID: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;
    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).where('subType', '==', subType).orderBy('timeStamp').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).where('subType', '==', subType).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadEmployeesByCompany(type: string, companyID: string, employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;
    let query = collectionRef.where('workInformation.companyRef.companyID', '==', companyID).where('workInformation.laidOff', '==', false).orderBy('uid').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('workInformation.companyRef.companyID', '==', companyID).where('employeeNumber', '==', employeeNumber).orderBy('uid').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadEmployees(type: string, employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;
    const query = collectionRef.where('workInformation.laidOff', '==', false).orderBy('uid').limit(batchSize);
    if (employeeNumber) {
      query.where('employeeNumber', '==', employeeNumber).orderBy('uid').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async employeeLoans(type: string, employeeNumber: string, startTime: Date, endTime: Date, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('createdAt', '>=', startTime).where('createdAt', '<=', endTime).where('status', '==', 'active').where('active', '==', true).orderBy('createdAt', 'asc').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('createdAt', '>=', startTime).where('createdAt', '<=', endTime).where('employeeRef.employeeNumber', '==', employeeNumber).orderBy('createdAt').limit(batchSize);
    }
    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async employeeLoansRetirement(batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeeLoans').ref;

    let query = collectionRef.where('active', '==', true).where('status', '==', 'active').where('type', '==', 'retirement').orderBy('approvedAt', 'asc').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }


  async loadEmployeeContributionsRetirement(type: string, employeeNumber: string, from: Date, to: Date): Promise<firebase.firestore.QuerySnapshot | null> {
    const collectionRef = this.firestore.collection(type).ref;

    return collectionRef.where('employeeNumber', '==', employeeNumber).where('grantDate', '>=', from).where('grantDate', '<=', to).get();
  }

  /**  */

  get downloadLinkReportActiveLoans(): string {
    let changedPost: string = '';
    if (this.real) {
      this.real.database.ref('reports').child('activeLoans').child('reportLink').on('value', function (snapshot) {
        changedPost = snapshot.val();
      });
    }
    return changedPost;

  }

  downloadLinkReport(type: string, companyID: string): Observable<any> {
    if (companyID !== '') {

      return this.firestore.collection('reportsURLs').doc(type).collection('companies').doc(companyID).valueChanges();

    } else {

      return this.firestore.collection('reportsURLs').doc(type).valueChanges();

    }

  }

  async supervisorPendingLoans(employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {

    const collectionRef = this.firestore.collection('employeesLoanList').ref;

    let query = collectionRef.where('active', '==', true).where('status', '==', 'active').where('supervisor.employeeNumber', '==', employeeNumber).orderBy('createdAt', 'asc').limit(batchSize);

    const result = this.scanQueryPendingWithArrayBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async pendingLoans(batchSize: number = 1000, callBackBefore: number = 2000, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {

    const collectionRef = this.firestore.collection('employeesLoanList').ref;
    let query = collectionRef.where('active', '==', true).where('status', '==', 'review').orderBy('createdAt', 'asc').limit(batchSize);
    const result = this.scanQueryPendingWithArrayBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>(), callBackFunction);
    return result;

  }

  async activePendingLoans(batchSize: number = 1000, callBackBefore: number = 2000, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeesLoanList').ref;
    let query = collectionRef.where('status', '==', 'active_pending').where('active', '==', true).orderBy('approvedAt').limit(batchSize);

    const result = this.scanQueryApprovedPendingWithArrayBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>(), callBackFunction);
    return result;

  }

  async employeeLoansByCompany(type: string, companyID: string, employeeNumber: string, startTime: Date, endTime: Date, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('createdAt', '>=', startTime).where('createdAt', '<=', endTime).where('employeeRef.companyID', '==', companyID).where('active', '==', true).where('status', '==', 'active').orderBy('createdAt').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('createdAt', '>=', startTime).where('createdAt', '<=', endTime).where('employeeRef.companyID', '==', companyID).where('employeeRef.employeeNumber', '==', employeeNumber).orderBy('createdAt').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }
  /*** funcion para reporte de facturacion
   * union de todos los saldos finales
  */

  async billing(type: string, employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('active', '==', true).where('status', '==', 'active').orderBy('createdAt').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('employeeRef.employeeNumber', '==', employeeNumber).orderBy('createdAt').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async billingByCompany(type: string, companyID: string, employeeNumber: string, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;
    let query = collectionRef.where('workInformation.companyRef.companyID', '==', companyID).orderBy('uid').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('workInformation.companyRef.companyID', '==', companyID).where('employeeNumber', '==', employeeNumber).orderBy('uid').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  /*** reportes SURA */

  async loadSura(type: string, employeeNumber: string): Promise<firebase.firestore.DocumentData | null> {
    const collectionRef = this.firestore.collection(type).ref;

    return collectionRef.where('employeeNumber', '==', employeeNumber).get();
  }

  async loadSuraByType(type: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.orderBy('timeStamp').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadSuraEY(type: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).orderBy('timeStamp').limit(batchSize);

    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  /*async loadActiveLoansAportExt(batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('reportBonusPercentage').ref;
    let query = collectionRef.orderBy('employeeNumber').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }*/

  async loadActiveLoansAportExt(reportStart: Date ,batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeeLoans').ref;
    let query = collectionRef.where('status', 'in', ['restructured', 'active']).where('approvedAt', '>', reportStart).orderBy('approvedAt', 'asc').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }


  async loadSuraByTypeAndCompany(type: string, companyID: string, employeeNumber: string, startTime: number, endTime: number, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).orderBy('timeStamp').limit(batchSize);
    if (employeeNumber) {
      query = collectionRef.where('timeStamp', '>=', startTime).where('timeStamp', '<=', endTime).where('companyID', '==', companyID).where('employeeNumber', '==', employeeNumber).orderBy('timeStamp').limit(batchSize);
    }

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async loadEmployeeLoanListReporte(periodID: string, savingAccount: boolean, batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeesLoanList').ref;
    let query = collectionRef.where('active', '==', true).where('parametersID', '==', periodID).where('employeeRef.activeSavingAccount', '==', savingAccount).where('status', '==', 'active_pending').orderBy('approvedAt').limit(batchSize);


    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }


  // temporal reestructura 
  async loadEmployeeLoanPending(batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('employeeLoans').ref;
    let query = collectionRef.where('status', '==', 'active_pending').where('active', '==', true).where('restructuredID', '>', '').orderBy('restructuredID', 'asc').limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }



  async scanQueryPendingWithArrayBatch(query: firebase.firestore.Query, batchSize: number, callBackBefore: number, last: any, results: Array<firebase.firestore.DocumentData>, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {

    console.log('results ' + results.length.toString());
    let shouldContinue = true;
    const snapshot = await query.startAfter(last).get();

    if (this.callbackPendingWithArray && ((results.length + snapshot.size) >= callBackBefore || snapshot.size === 0)) {
      shouldContinue = await this.callbackPendingWithArray(results);
      results.splice(0, results.length);
    }

    if (snapshot.size === 0 || shouldContinue === false) {
      console.log('************ Done with lastStored ' + last + ' ***************');
      return results;
    }


    let newLast: any;
    for (const doc of snapshot.docs) {

      const obj: any = doc.exists ? doc.data() : null;
      newLast = doc;
      results.push(obj);

    }

    console.log('************ lastStored ' + newLast + ' ***************');
    const r = await this.scanQueryPendingWithArrayBatch(query, batchSize, callBackBefore, newLast, results);
    return r;

  }

  async scanQueryApprovedPendingWithArrayBatch(query: firebase.firestore.Query, batchSize: number, callBackBefore: number, last: any, results: Array<firebase.firestore.DocumentData>, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {

    //console.log('results ' + results.length.toString());
    let shouldContinue = true;
    const snapshot = await query.startAfter(last).get();

    if (this.callbackApprovedPendingWithArray && ((results.length + snapshot.size) >= callBackBefore || snapshot.size === 0)) {
      shouldContinue = await this.callbackApprovedPendingWithArray(results);
      results.splice(0, results.length);
    }

    if (snapshot.size === 0 || shouldContinue === false) {
      console.log('************ Done with lastStored ' + last + ' ***************');
      return results;
    }


    let newLast: any;
    for (const doc of snapshot.docs) {

      const obj: any = doc.exists ? doc.data() : null;
      newLast = doc;
      results.push(obj);

    }

    console.log('************ lastStored ' + newLast + ' ***************');
    const r = await this.scanQueryApprovedPendingWithArrayBatch(query, batchSize, callBackBefore, newLast, results);
    return r;

  }

  async scanQueryBatch(query: firebase.firestore.Query, batchSize: number, callBackBefore: number, last: any, results: Array<firebase.firestore.DocumentData>, callBackFunction: ((batchResults: Array<any>) => Promise<boolean>) | null = null): Promise<Array<firebase.firestore.DocumentData>> {

    console.log('results ' + results.length.toString());
    let shouldContinue = true;
    const snapshot = await query.startAfter(last).get();

    if (this.callbackWithArray && ((results.length + snapshot.size) >= callBackBefore || snapshot.size === 0)) {
      shouldContinue = await this.callbackWithArray(results);
      results.splice(0, results.length);
    }

    if (snapshot.size === 0 || shouldContinue === false) {
      console.log('************ Done with lastStored ' + last + ' ***************');
      return results;
    }


    let newLast: any;
    for (const doc of snapshot.docs) {

      const obj: any = doc.exists ? doc.data() : null;
      newLast = doc;
      results.push(obj);

    }

    console.log('************ lastStored ' + newLast + ' ***************');
    const r = await this.scanQueryBatch(query, batchSize, callBackBefore, newLast, results);
    return r;

  }

  /**
   *
   * @param type nombre de la coleccion
   * @param startTime restriccion de el tiempo inicio
   * @param endTime restriccion de el tiempo fin
   * @param page numero de pagina actual
   * @param size total de elementos por pagina
   */
  async logs(type: string, page: number = 1, size: number = 50): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection(type).ref;

    let query = collectionRef.orderBy('createdAt').limit(size);

    const result = this.paginationBatch(query, page, size, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  /**
   * 
   * @param parameter parametros iniciales para insertar en la coleccion
   * @param action accion registrada
   */
  async saveLogEmployeeLoanChanges(parameter: any, action: string) {

    let parameterLogs = {
      loanID: parameter.loanID,
      employeeNumber: parameter.employeeRef.employeeNumber,
      requestedAmount: parameter.requestedAmount,
      type: parameter.type,
      status: parameter.status,
      createdAt: parameter.createdAt,
      action: action
    }
    const id = this.firestore.createId();
    return this.firestore.collection('logEmployeeLoanChanges').doc(id).set(parameterLogs);

  }

  async saveLogAdministratorActions(parameter: any, action: string) {
    parameter.action = action;
    const id = this.firestore.createId();
    return this.firestore.collection('logAdministratorActions').doc(id).set(parameter);

  }

  async saveLogPermanentLoanMovements(parameter: any) {

    const id = this.firestore.createId();
    return this.firestore.collection('logPermanentLoanMovements').doc(id).set(parameter);

  }
  /** funcion paginadora */
  /**
   *
   * @param query consulta a ejecutarse n - veces
   * @param page numero de pagina actual
   * @param size total de elementos por pagina
   * @param last
   * @param results
   */
  async paginationBatch(query: firebase.firestore.Query, page: number, size: number, last: any, results: Array<firebase.firestore.DocumentData>): Promise<Array<firebase.firestore.DocumentData>> {

    console.log('results ' + results.length.toString());
    console.log('last', last);

    const snapshot = await query.startAfter(last).get();

    if (this.callbackWithArray && ((results.length + snapshot.size) >= size || snapshot.size === 0)) {
      await this.callbackWithArray(results);
      results.splice(0, results.length);
    }

    if (snapshot.size === 0) {
      console.log('************ Done with lastStored ' + last + ' ***************');
      return results;
    }


    let newLast: any;
    let documento: any;
    for (const doc of snapshot.docs) {
      const obj: any = doc.exists ? doc.data() : null;
      newLast = doc;
      results.push(obj);
      documento = obj;

    }

    console.log('************ lastStored ' + documento + ' ***************');
    const r = await this.paginationBatch(query, page, size, newLast, results);
    return r;


  }

  async createDRFile(includedCompanies: string[], savingType: ContributionTypesEnum, investmentReturnAmount: number) {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append( 'Content-Type', 'application/json');

    return this.http.post(this.baseURL+'/startInvestmentReturnDistribution', { companies: includedCompanies, savingType, investmentReturnAmount } , {headers}).toPromise();
  }

  async getInvestmentReturnValidationFile(savingType: ContributionTypesEnum) {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append( 'Content-Type', 'application/json');

    return this.http.post(this.baseURL+'/getInvestmentReturnValidationFile', { savingType }, { headers }).toPromise();
  }

  async rejectInvestmentReturn(savingType: ContributionTypesEnum) {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append( 'Content-Type', 'application/json');

    return this.http.post(this.baseURL + '/rejectInvestmentReturn', { savingType }, { headers }).toPromise();
  }

  async distributeDR(savingType: string, executionDate: string) {
    const headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append( 'Content-Type', 'application/json');

    return this.http.post(this.baseURL + '/sendRevenuesToM4', { savingType, executionDate, startAfter: '' }, { headers }).toPromise();
  }

  checkInvestmentReturnStatus(savingType: string): firebase.database.Reference {

    return this.real.database.ref(`investmentReturn/${savingType}`)
  }

  async reportFromLog(key: any): Promise<firebase.database.DataSnapshot | null> {

    return this.real.database.ref('logs').child('loanTemp').orderByChild('requestDate').startAt(key).once('value');
  }


  async addEmployeesToVEABBonus(employees: Array<number>): Promise<void> {
    const batch = this.firestore.firestore.batch();

    for (const employee of employees) {
      const ref = this.firestore.collection('users').doc(employee.toString()).ref;
      batch.set(ref, { isVeabBonusActive: true }, { merge: true });
    }

    await batch.commit();

    return;
  }

  async removeEmployeesToVEABBonus( employees: Array<number> ): Promise<void> {
    const batch = this.firestore.firestore.batch();

    for (const employee of employees) {
      const ref = this.firestore.collection('users').doc(employee.toString()).ref;
      batch.set(ref, { isVeabBonusActive: false }, { merge: true} );
    }

    await batch.commit();

    return;
  }

  loadEmployeesWithActiveVEAB(batchSize: number = 1000, callBackBefore: number = 2000): Promise<Array<firebase.firestore.DocumentData>> {
    const collectionRef = this.firestore.collection('users').ref;

    let query = collectionRef.where('isVeabBonusActive', '==', true).orderBy("uid").limit(batchSize);

    const result = this.scanQueryBatch(query, batchSize, callBackBefore, null, new Array<firebase.firestore.DocumentData>());
    return result;
  }

  async setEmployeeVEABBonusToZero(employees: Array<number>): Promise<void> {
    const batch = this.firestore.firestore.batch();

    for (const employee of employees) {
      const ref = this.firestore.collection('permanentSavings').doc(employee.toString()).ref;
      batch.set(ref, { veabBonus: 0 }, { merge: true });
    }

    await batch.commit();

    return;
  }
}
